import { Provider } from "react-redux"
import App, { Container } from "next/app"
import Helmet from "react-helmet"
import NProgress from "nprogress"
import React from "react"
import Router from "next/router"

// Redux Store, Datalayer GTM
import withRedux from "next-redux-wrapper"
import { RESET_STORE } from "../modules/commonActions"
import configureStore from "../store"
import GTM from "../libs/services/google/SetGtmHead"
import setDataLayer from "../libs/internal/google/datalayer"

// Google Fonts
import FontFaceObserver from "fontfaceobserver"
const Fonts = () => {
	const Mitr = new FontFaceObserver("Mitr")
	Mitr.load().then(() => {
		document.documentElement.classList.add("mitr")
	})
}

// NProgress Router
Router.events.on("routeChangeStart", () => NProgress.start())
Router.events.on("routeChangeComplete", () => NProgress.done())
Router.events.on("routeChangeError", () => NProgress.done())

class MyApp extends App {
	state = {
		statusCode: 200,
	}

	static async getInitialProps({ Component, router, ctx }) {
		let pageProps = {}
		const isServer = !process.browser
		const previousUrl = router.asPath
		const asyncFn = Component.getInitialProps
		await ctx.store.dispatch(RESET_STORE())

		if (ctx.req) Helmet.renderStatic()
		if (!isServer) return { asyncFn, ctx, pageProps }
		if (asyncFn) pageProps = await asyncFn(ctx)

		return { pageProps, previousUrl }
	}

	async componentDidMount() {
		Fonts() // Load font when Dom Ready

		const { asyncFn, ctx, store } = this.props

		if (!asyncFn) return

		const asyncProps = await asyncFn(ctx)

		this.setState({ ...asyncProps })
	}

	async componentDidUpdate(prevProps) {
		if (prevProps.pageProps !== this.props.pageProps) {
			const { asyncFn, ctx, store } = this.props

			if (!asyncFn) return

			const asyncProps = await asyncFn(ctx)

			// Datalayer GTM Push
			dataLayer.push(setDataLayer(store.getState().common))

			this.setState({ ...asyncProps })
		}
	}

	render() {
		const { Component, pageProps, store } = this.props
		const dataStoreCommon = store.getState().common

		return (
			<Container>
				<GTM dataStore={dataStoreCommon.data} page={dataStoreCommon.page} statusCode={dataStoreCommon.statusCode} />
				<Provider store={store}>
					<Component {...this.state} {...pageProps} />
				</Provider>
			</Container>
		)
	}
}

export default withRedux(configureStore)(MyApp)
